import CommonHelper from '../teemapp/common-helper';
import Swal from '../teemapp/sweetalert2';
import i18n from '../teemapp/i18n';
import { otp as OTP_API, shop as SHOP_API } from '@teem-app/shop/constants/api';

var OtpPinModule = (function (CommonHelper) {
	var mdl = {};

	mdl.urls = {
		store_order: SHOP_API.storeOrder,
		verify_opt: OTP_API.verifyOtpPin,
		resend_opt: OTP_API.resendOtpPin
	}

	mdl.verifyOtpPin = {
		errorPlacement: function (error, element) {
			$(element).closest('fieldset').find('.field-error').text(error.text());
		},
		rules: {
			number_1: {
				required: true,
				maxlength: 1,
				digits: true
			},
			number_2: {
				required: true,
				maxlength: 1,
				digits: true
			},
			number_3: {
				required: true,
				maxlength: 1,
				digits: true
			},
			number_4: {
				required: true,
				maxlength: 1,
				digits: true
			}
		},
		submitHandler: function (form) {
			// event.preventDefault();
			let data = CommonHelper.getFormData(form);
			let new_otp = data.number_1 + data.number_2 + data.number_3 + data.number_4;
			console.log(new_otp);
			$.ajax({
				url: mdl.urls.verify_opt,
				type: 'post',
				data: {
					'otp': new_otp,
					'uuid': $('#store-uuid').val(),
                    'phone': $('#phone-number').val()
				},
				beforeSend: function () {
					CommonHelper.showLoading(true);
				},
				success: function (r) {
					CommonHelper.showLoading(false);
					let formData = CommonHelper.getFormData($("#pickUpForm"))
					if (isObjectEmpty(formData)) {
						formData = CommonHelper.getFormData($("#deliveryForm"))
					}
					$('.otp-pin__wrong').removeClass('d-none');
					$('.otp-pin__wrong').text(r.message);
					// CommonHelper.showLoading(true);
					mdl.storeOrder(formData);
				},
				error: function (xhr, textStatus, errorThrown) {
					CommonHelper.showLoading(false);
					if (xhr.status == 403) {
						$('.otp-pin__wrong').removeClass('d-none');
						$('.otp-pin__wrong').text(xhr.responseJSON.error);
						// Swal.fire(i18n.t('front_pages.error'), xhr.responseJSON.message, 'error');
						// mdl.otpSendValidator.showErrors(xhr.responseJSON.errors);
					}
				}
			}).always(function (data, textStatus, jqXHR) {
				// CommonHelper.showLoading(false);
			})

			return false;
		}
	};

	mdl.storeOrder = function(formData) {
		$.ajax({
			url: mdl.urls.store_order,
			type: 'post',
			data: formData,
			beforeSend: function () {
				CommonHelper.showLoading(true);
			},
			success: function (r) {
				CommonHelper.showLoading(false);
				$('#otp-pin-code').modal('hide');
				let order = r.order;
				// mdl.openThankYouModal();
				if (r.online_payment) {
					window.location.href = `${baseUrl}/order/${order.uuid}/checkout`
				} else 
				{
					window.location.replace(`${baseUrl}/order/${order.uuid}/thank-you`);
				}
				
				// if (order.type && (order.type == 'service') ) {
				// 	window.location.replace(`${baseUrl}/services/order/${order.uuid}/thank-you`);
				// } else {
				// 	window.location.replace(`${baseUrl}/order/${order.uuid}/thank-you`);
				// }
			},
			error: function (xhr, textStatus, errorThrown) {
				CommonHelper.showLoading(false);
				
				// if (xhr.status == 403) {
					Swal.fire(i18n.t('front_pages.error'), xhr.responseJSON.error, 'error');
				// }
			}
		}).always(function (data, textStatus, jqXHR) {
			// CommonHelper.showLoading(true);
		})
	}

	mdl.openThankYouModal = function (e) {
		$('#thank-you-modal').modal('show');
	}

	mdl.init = function () {
		mdl.bindSelectors();
		mdl.bindFormValidations();
		mdl.resendOtp();
		mdl.resendOrderOtp();
		mdl.numberInputValidation();
	}

	mdl.numberInputValidation = function () {
		$(document).on('click', '.opt-num', function (e) {
			$('.otp-pin__wrong').addClass('d-none');
			$(this).val('');
		});

		$(document).on('keyup', '.opt-num', function (e) {
			$('.otp-pin__wrong').addClass('d-none');
			this.value = this.value.replace(/[^0-9]/g, '');
			// if (this.value.length == 1) {
			// 	$(this).parent().next().find('input').focus();
			// }
			if (this.value.length == 1) {
				$(this).parent().next().find('input').focus();
				$(this).parent().next().find('input').val('');
			} else if (this.value.length > 1) {
				var new_val = this.value.substring(1, 2);
				$(this).val(new_val);
				$(this).parent().next().find('input').focus();
				$(this).parent().next().find('input').val('');
			} else if (e.keyCode == 8) {
				if ($(this).parent().prev('fieldset').find('input')) {
					$(this).parent().prev('fieldset').find('input').focus();
					$(this).parent().prev('fieldset').find('input').val('');
				}
			}
		});
	}

	mdl.resendOtp = function () {
		$('#resendCode').click(function (e) {
			e.preventDefault();
			$.ajax({
				url: mdl.urls.resend_opt,
				type: 'post',
				data: {
					uuid: $('#uuid').val()
				},
				beforeSend: function () {
					CommonHelper.showLoading(true);
				},
				success: function (r) {
					Swal.fire(i18n.t('front_pages.done'), r.message, 'success').then(function () {
						// window.location.href = baseUrl;
					})
				},
				error: function (xhr) {
					console.log(xhr);
				}
			}).always(function (data, textStatus, jqXHR) {
				CommonHelper.showLoading(false);
			});
		});
	}

	mdl.resendOrderOtp = function () {
		$('#resend-otp-pin').click(function (e) {

			let countryCode = $('#countryCode').val();
			let phone = $('#phone-number').val();
			let storeUuid = $('#store-uuid').val();
			let firstName = $('#first_name').val();
			let lastName = $('#last_name').val();
			let email = $('#email').val();

			e.preventDefault();
			$.ajax({
				url: mdl.urls.resend_opt,
				type: 'post',
				data: { phone: phone, store_uuid: storeUuid, first_name: firstName, last_name: lastName, email: email },
				beforeSend: function () {
					CommonHelper.showLoading(true);
				},
				success: function (r) {
					CommonHelper.showLoading(false);
					if (r.status == true) {
						notify(resultData.message);
					}
				},
				error: function (xhr) {
					console.log(xhr);
				}
			}).always(function (data, textStatus, jqXHR) {
				CommonHelper.showLoading(false);
			});
		});
	}

	mdl.bindFormValidations = function () {
		mdl.otpSendValidator = mdl.selectors.otpPinSendForm.validate(mdl.verifyOtpPin)
	}

	mdl.bindSelectors = function () {
		mdl.selectors = {
			otpPinSendForm: $('#otpPinSendForm')
		}
	}

	return mdl;
})(CommonHelper);

export default OtpPinModule;
